// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-menu {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 948px;
  padding: 0 24px;
  box-sizing: border-box;
  color: var(--text-color);
  z-index: 100;
}

/* On wide (workspace) routes the header follows the full content width, with
   the same gutter the wide PageShell uses, so it aligns with the board. */
html[data-shell-variant='wide'] .header-menu {
  max-width: none;
  padding-left: 24px;
  padding-right: 24px;
}

.logo {
  font-family: var(--font-display);
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  cursor: pointer;
}

.nav-items {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.user-menu {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* The header sits directly on the page ground, so its menu trigger takes the
   same raised fill as the search fields instead of showing the ground through
   itself.

   Scoped to this button rather than .lightButton, which it uses: that class has
   127 usages and many of them sit ON a card, where --surface-raised IS the card
   colour in dark mode — a global fill would make those disappear. Transparent
   stays the right default there; only chrome on the page ground wants a fill.

   The ID outranks .lightButton:not(:disabled):hover, so the hover fill has to
   be restated here or it would be swallowed. */
#user-menu-button {
  background-color: var(--surface-raised);
}

#user-menu-button:not(:disabled):hover {
  background-color: var(--accent-tint);
}

.dropdown-menu {
  position: absolute;
  right: 0;
  top: 100%;
  background: var(--dropdown-bg);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  z-index: 2000;
  min-width: 10em;
  margin-top: 0.5rem;
}

.dropdown-item {
  padding: 0.5rem 1rem;
  display: block;
  color: var(--text-color);
  text-decoration: none;
  margin: 0.25rem 0;
  text-align: left;
  width: 100%;
  border-radius: var(--radius-sm);
  box-sizing: border-box;
}

.dropdown-item:hover {
  background-color: var(--dropdown-hover);
}

.logout-button {
  background: none;
  border: none;
  color: var(--text-color);
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 1rem;
  width: 100%;
  text-align: left;
  box-sizing: border-box;
}

/* Logout is an AsyncButton, whose internal grid centers its label by
   default. Left-align it so it matches the Link items above it. */
.dropdown-menu .logout-button .async-button__sizer {
  width: 100%;
  justify-items: start;
}

.dropdown-menu .logout-button .async-button__content,
.dropdown-menu .logout-button .async-button__loading {
  justify-content: flex-start;
}

@media (max-width: 768px) {
  .header-menu {
    padding: 0 16px;
  }

  .nav-items,
  .user-menu {
    min-width: 0;
  }

  #user-menu-button {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .jobs-dropdown {
    width: 100vw;
    left: calc(-50vw + 50%);
    right: auto;
    max-width: none;
  }
}

/* Jobs Status Icon and Dropdown Styles */
.jobs-status-container {
  position: relative;
  margin-right: 10px;
}

.jobs-status-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.jobs-status-button:hover {
  background-color: var(--card-hover);
}

.jobs-status-icon {
  position: relative;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.jobs-count {
  position: absolute;
  font-size: 12px;
  font-weight: bold;
  color: var(--text-color);
  z-index: 2;
}

.jobs-check-icon {
  position: absolute;
  font-size: 12px;
  color: var(--secondary-text-color);
  z-index: 2;
}

.jobs-progress {
  width: 30px;
  height: 30px;
  transform: rotate(-90deg);
}

.jobs-progress-bg {
  fill: none;
  stroke: var(--card-background);
  stroke-width: 2.8;
}

.jobs-progress-fill {
  fill: none;
  stroke: var(--button-primary-bg);
  stroke-width: 2.8;
  stroke-linecap: butt;
  transition: stroke-dasharray 0.3s ease;
}

.jobs-progress-fill.active {
  stroke: var(--button-primary-bg);
  stroke-dasharray: 6, 6;
  animation: circle-progress-animation 1s linear infinite;
}

.jobs-progress-fill.completed {
  stroke: var(--secondary-text-color);
  stroke-linecap: butt;
  stroke-dasharray: 6, 6;
}

.jobs-dropdown {
  width: 300px;
  max-height: 400px;
  overflow-y: auto;
  right: -10px;
}

.jobs-dropdown-header {
  padding: 0.5rem 1rem;
  border-bottom: 1px solid var(--border-color);
}

.jobs-dropdown-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

.job-item {
  padding: 15px;
  border-bottom: 1px solid var(--border-color);
}

.job-item:last-of-type {
  border-bottom: none;
  padding-bottom: 0px;
}

.job-item.clickable:hover {
  background-color: var(--dropdown-hover);
}

.job-agent-team {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.5rem;
  font-size: 0.85rem;
  color: var(--secondary-text-color);
}

.job-header {
  margin-bottom: 0.5rem;
}

.job-name {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.job-time-and-cancel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
}

.job-time {
  flex: 1;
}

.job-cancel-div {
  flex-shrink: 0;
}

.job-cancel-link {
  background: none;
  border: none;
  color: var(--secondary-text-color);
  font-size: 0.75rem;
  cursor: pointer;
  padding: 10px;
  border-radius: 2px;
  text-decoration: underline;
  flex-shrink: 0;
}

.job-cancel-link:hover {
  color: #ef4444;
  background-color: var(--card-hover);
}

.header-job-progress-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 8px;
}

.job-progress-bar {
  height: 6px;
  background-color: var(--card-background);
  border-radius: 3px;
  overflow: hidden;
  flex-grow: 1;
  width: 100%;
}

.job-progress-percent {
  font-size: 0.85rem;
  color: var(--secondary-text-color);
  white-space: nowrap;
}

.job-progress-bar.active .job-progress-fill {
  background: repeating-linear-gradient(
    45deg,
    var(--button-primary-bg),
    var(--button-primary-bg) 10px,
    var(--button-primary-hover) 10px,
    var(--button-primary-hover) 20px
  );
  animation: progress-animation 1s linear infinite;
}

.job-progress-bar.pending .job-progress-fill {
  background: repeating-linear-gradient(
    45deg,
    var(--secondary-text-color),
    var(--secondary-text-color) 10px,
    var(--border-color) 10px,
    var(--border-color) 20px
  );
  animation: progress-animation 1s linear infinite;
}

.job-progress-bar.completed .job-progress-fill,
.job-progress-bar.error .job-progress-fill {
  background-color: var(--secondary-text-color);
}

.job-progress-bar.canceled .job-progress-fill {
  background-color: var(--border-color);
}

.job-progress-fill {
  height: 100%;
  background-color: var(--button-primary-bg);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.job-progress-fill.canceled {
  background-color: var(--border-color);
}

.job-started-time {
  font-size: 0.75rem;
  color: var(--secondary-text-color);
  margin-top: 0.5rem;
  margin-bottom: 0.25rem;
  text-align: left;
}

.job-status-description {
  font-size: 0.85rem;
  color: var(--secondary-text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

/* Ensure all text in job items is left-aligned */
.job-item,
.job-agent-team,
.job-header,
.job-name,
.job-progress-percent,
.job-started-time,
.job-status-description {
  text-align: left;
}

.no-jobs-message {
  padding: 1rem;
  text-align: center;
  color: var(--secondary-text-color);
}

.no-jobs-sub-text {
  font-size: 0.5em;
  display: block;
  margin-top: 1.5em;
}

@keyframes progress-animation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 28px 0;
  }
}

@keyframes circle-progress-animation {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 12;
  }
}

/* Notifications bell (replaces the jobs indicator) */
.notifications-bell {
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--secondary-text-color);
  padding: 8px;
  margin-right: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.notifications-bell:hover {
  color: var(--text-color);
  background-color: var(--button-pill-hover-bg, rgba(128, 128, 128, 0.15));
}

.notifications-badge {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: var(--radius);
  background-color: var(--button-primary-bg, #2563eb);
  color: #fff;
  font-size: 0.65rem;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/header-menu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;AACd;;AAEA;0EAC0E;AAC1E;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;;;;;;;+CAU+C;AAC/C;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;kEACkE;AAClE;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;;;;;;GAMC;EACD,gDAAgD;AAClD;;AAEA;EACE;;;;;;GAMC;EACD,gDAAgD;AAClD;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,mDAAmD;EACnD,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":[".header-menu {\n  position: absolute;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 948px;\n  padding: 0 24px;\n  box-sizing: border-box;\n  color: var(--text-color);\n  z-index: 100;\n}\n\n/* On wide (workspace) routes the header follows the full content width, with\n   the same gutter the wide PageShell uses, so it aligns with the board. */\nhtml[data-shell-variant='wide'] .header-menu {\n  max-width: none;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.logo {\n  font-family: var(--font-display);\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  cursor: pointer;\n}\n\n.nav-items {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n\n.user-menu {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* The header sits directly on the page ground, so its menu trigger takes the\n   same raised fill as the search fields instead of showing the ground through\n   itself.\n\n   Scoped to this button rather than .lightButton, which it uses: that class has\n   127 usages and many of them sit ON a card, where --surface-raised IS the card\n   colour in dark mode — a global fill would make those disappear. Transparent\n   stays the right default there; only chrome on the page ground wants a fill.\n\n   The ID outranks .lightButton:not(:disabled):hover, so the hover fill has to\n   be restated here or it would be swallowed. */\n#user-menu-button {\n  background-color: var(--surface-raised);\n}\n\n#user-menu-button:not(:disabled):hover {\n  background-color: var(--accent-tint);\n}\n\n.dropdown-menu {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  background: var(--dropdown-bg);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  z-index: 2000;\n  min-width: 10em;\n  margin-top: 0.5rem;\n}\n\n.dropdown-item {\n  padding: 0.5rem 1rem;\n  display: block;\n  color: var(--text-color);\n  text-decoration: none;\n  margin: 0.25rem 0;\n  text-align: left;\n  width: 100%;\n  border-radius: var(--radius-sm);\n  box-sizing: border-box;\n}\n\n.dropdown-item:hover {\n  background-color: var(--dropdown-hover);\n}\n\n.logout-button {\n  background: none;\n  border: none;\n  color: var(--text-color);\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n  font-size: 1rem;\n  width: 100%;\n  text-align: left;\n  box-sizing: border-box;\n}\n\n/* Logout is an AsyncButton, whose internal grid centers its label by\n   default. Left-align it so it matches the Link items above it. */\n.dropdown-menu .logout-button .async-button__sizer {\n  width: 100%;\n  justify-items: start;\n}\n\n.dropdown-menu .logout-button .async-button__content,\n.dropdown-menu .logout-button .async-button__loading {\n  justify-content: flex-start;\n}\n\n@media (max-width: 768px) {\n  .header-menu {\n    padding: 0 16px;\n  }\n\n  .nav-items,\n  .user-menu {\n    min-width: 0;\n  }\n\n  #user-menu-button {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .jobs-dropdown {\n    width: 100vw;\n    left: calc(-50vw + 50%);\n    right: auto;\n    max-width: none;\n  }\n}\n\n/* Jobs Status Icon and Dropdown Styles */\n.jobs-status-container {\n  position: relative;\n  margin-right: 10px;\n}\n\n.jobs-status-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  transition: background-color 0.3s;\n}\n\n.jobs-status-button:hover {\n  background-color: var(--card-hover);\n}\n\n.jobs-status-icon {\n  position: relative;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.jobs-count {\n  position: absolute;\n  font-size: 12px;\n  font-weight: bold;\n  color: var(--text-color);\n  z-index: 2;\n}\n\n.jobs-check-icon {\n  position: absolute;\n  font-size: 12px;\n  color: var(--secondary-text-color);\n  z-index: 2;\n}\n\n.jobs-progress {\n  width: 30px;\n  height: 30px;\n  transform: rotate(-90deg);\n}\n\n.jobs-progress-bg {\n  fill: none;\n  stroke: var(--card-background);\n  stroke-width: 2.8;\n}\n\n.jobs-progress-fill {\n  fill: none;\n  stroke: var(--button-primary-bg);\n  stroke-width: 2.8;\n  stroke-linecap: butt;\n  transition: stroke-dasharray 0.3s ease;\n}\n\n.jobs-progress-fill.active {\n  stroke: var(--button-primary-bg);\n  stroke-dasharray: 6, 6;\n  animation: circle-progress-animation 1s linear infinite;\n}\n\n.jobs-progress-fill.completed {\n  stroke: var(--secondary-text-color);\n  stroke-linecap: butt;\n  stroke-dasharray: 6, 6;\n}\n\n.jobs-dropdown {\n  width: 300px;\n  max-height: 400px;\n  overflow-y: auto;\n  right: -10px;\n}\n\n.jobs-dropdown-header {\n  padding: 0.5rem 1rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.jobs-dropdown-header h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.job-item {\n  padding: 15px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.job-item:last-of-type {\n  border-bottom: none;\n  padding-bottom: 0px;\n}\n\n.job-item.clickable:hover {\n  background-color: var(--dropdown-hover);\n}\n\n.job-agent-team {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 0.5rem;\n  font-size: 0.85rem;\n  color: var(--secondary-text-color);\n}\n\n.job-header {\n  margin-bottom: 0.5rem;\n}\n\n.job-name {\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n\n.job-time-and-cancel {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 0.5rem;\n}\n\n.job-time {\n  flex: 1;\n}\n\n.job-cancel-div {\n  flex-shrink: 0;\n}\n\n.job-cancel-link {\n  background: none;\n  border: none;\n  color: var(--secondary-text-color);\n  font-size: 0.75rem;\n  cursor: pointer;\n  padding: 10px;\n  border-radius: 2px;\n  text-decoration: underline;\n  flex-shrink: 0;\n}\n\n.job-cancel-link:hover {\n  color: #ef4444;\n  background-color: var(--card-hover);\n}\n\n.header-job-progress-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  gap: 8px;\n}\n\n.job-progress-bar {\n  height: 6px;\n  background-color: var(--card-background);\n  border-radius: 3px;\n  overflow: hidden;\n  flex-grow: 1;\n  width: 100%;\n}\n\n.job-progress-percent {\n  font-size: 0.85rem;\n  color: var(--secondary-text-color);\n  white-space: nowrap;\n}\n\n.job-progress-bar.active .job-progress-fill {\n  background: repeating-linear-gradient(\n    45deg,\n    var(--button-primary-bg),\n    var(--button-primary-bg) 10px,\n    var(--button-primary-hover) 10px,\n    var(--button-primary-hover) 20px\n  );\n  animation: progress-animation 1s linear infinite;\n}\n\n.job-progress-bar.pending .job-progress-fill {\n  background: repeating-linear-gradient(\n    45deg,\n    var(--secondary-text-color),\n    var(--secondary-text-color) 10px,\n    var(--border-color) 10px,\n    var(--border-color) 20px\n  );\n  animation: progress-animation 1s linear infinite;\n}\n\n.job-progress-bar.completed .job-progress-fill,\n.job-progress-bar.error .job-progress-fill {\n  background-color: var(--secondary-text-color);\n}\n\n.job-progress-bar.canceled .job-progress-fill {\n  background-color: var(--border-color);\n}\n\n.job-progress-fill {\n  height: 100%;\n  background-color: var(--button-primary-bg);\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n.job-progress-fill.canceled {\n  background-color: var(--border-color);\n}\n\n.job-started-time {\n  font-size: 0.75rem;\n  color: var(--secondary-text-color);\n  margin-top: 0.5rem;\n  margin-bottom: 0.25rem;\n  text-align: left;\n}\n\n.job-status-description {\n  font-size: 0.85rem;\n  color: var(--secondary-text-color);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n}\n\n/* Ensure all text in job items is left-aligned */\n.job-item,\n.job-agent-team,\n.job-header,\n.job-name,\n.job-progress-percent,\n.job-started-time,\n.job-status-description {\n  text-align: left;\n}\n\n.no-jobs-message {\n  padding: 1rem;\n  text-align: center;\n  color: var(--secondary-text-color);\n}\n\n.no-jobs-sub-text {\n  font-size: 0.5em;\n  display: block;\n  margin-top: 1.5em;\n}\n\n@keyframes progress-animation {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 28px 0;\n  }\n}\n\n@keyframes circle-progress-animation {\n  0% {\n    stroke-dashoffset: 0;\n  }\n  100% {\n    stroke-dashoffset: 12;\n  }\n}\n\n/* Notifications bell (replaces the jobs indicator) */\n.notifications-bell {\n  position: relative;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--secondary-text-color);\n  padding: 8px;\n  margin-right: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.notifications-bell:hover {\n  color: var(--text-color);\n  background-color: var(--button-pill-hover-bg, rgba(128, 128, 128, 0.15));\n}\n\n.notifications-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: var(--radius);\n  background-color: var(--button-primary-bg, #2563eb);\n  color: #fff;\n  font-size: 0.65rem;\n  font-weight: 600;\n  line-height: 16px;\n  text-align: center;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
